import idb from "idb";

class Store {
    constructor(name) {
        this.objects = name + "-objects";
        this.dbPromise = idb.open(name, 1, upgradeDB => {
            upgradeDB.createObjectStore(this.objects);
        });
    }

    async set(key, value) {
        const db = await this.dbPromise;
        const tx = db.transaction(this.objects, "readwrite");
        tx.objectStore(this.objects).put(value, key);
        return tx.complete;
    }

    async get(key) {
        const db = await this.dbPromise;
        return db.transaction(this.objects).objectStore(this.objects).get(key);
    }
}

export default Store;



// WEBPACK FOOTER //
// ./src/Store.js